export const APPSETTINGS_REQUEST = 'APPSETTINGS_REQUEST';
export const APPSETTINGS_SUCCESS = 'APPSETTINGS_SUCCESS';
export const APPSETTINGS_FAIL = 'APPSETTINGS_FAIL';
export const APPSETTINGS_UPDATE_REQUEST = 'APPSETTINGS_UPDATE_REQUEST';
export const APPSETTINGS_UPDATE_SUCCESS = 'APPSETTINGS_UPDATE_SUCCESS';
export const APPSETTINGS_UPDATE_FAIL = 'APPSETTINGS_UPDATE_FAIL';